export default __webpack_public_path__ + "static/media/dna.6171da86.png";